"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, MapPin, PhoneCall, CircleCheck as CheckCircle2, ArrowRight } from 'lucide-react';
export default function ReliabilityInfo() {
  const sectionReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Safety First",
    desc: "Professional chauffeurs and premium vehicles maintained to the highest standards.",
    icon: ShieldCheck
  }, {
    title: "LA Experts",
    desc: "Deep knowledge of Southern California routes ensuring timely arrivals.",
    icon: MapPin
  }, {
    title: "24/7 Support",
    desc: "Dedicated dispatch team available around the clock for your needs.",
    icon: PhoneCall
  }];
  const listItems = ["24/7 availability for all bookings", "Responsive reservation & dispatch team", "Proactive chauffeur communication", "Strict early arrival standards", "Flexible transportation coordination"];
  return <section id="reliabilityinfo" ref={sectionReveal.ref} className="w-full bg-bg-secondary py-20 md:py-32 overflow-hidden transition-opacity duration-700 opacity-100 !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/06/final.jpg)]">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/06/new.jpg)]">
          
          {}
          

          {}
          <div className="order-1 lg:order-2 relative">
            

            {}
            <div className="hidden md:block absolute -bottom-10 -left-10 z-20 max-w-xs">
              
            </div>

            {}
            
            
          </div>

        </div>

        {}
        
      </div>
    </section>;
}